import Avatar from "../Tools/Avatar";
import { useContext } from 'react';
import UserContext from '../../services/Context/UserContext';

export default function User(){

    const {user} = useContext(UserContext)

    return user && 
        <div className='layout-user'>
            <Avatar color={user.category?.color} initials={user.initials} size={44}/>
            <span className='layout-user-name'>{user.name}</span>
        </div>
}
